import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import Drawer from "react-modern-drawer";
import { useNavigate, useParams } from "react-router-dom";
import TopNavigation from "../../components/TopNavigation";
import CameraRecorder from "../../components/CameraRecorder";
import {
  AttachmentDialog,
  SubmitCreateReportDialogSuccess,
  SubmitCreateReportDialogValidation,
  ConfirmationDialog,
} from "../../components/DialogCollection";
import * as Assets from "../../utils/svg_assets";
import "./style.scss";
import {
  Container,
  Form,
  ListGroup,
  ListGroupItem,
  Row,
  Col,
} from "react-bootstrap";

const initPayload = {
  title: "",
  description: "",
  img: "",
  img2: "",
  img3: "",
  video: "",
  file: "",
};

const CreateReportPage = (props) => {
  const navigate = useNavigate();
  const params = useParams();
  const { submitCreateReport } = props;
  const titleRef = useRef(null);
  const articleRef = useRef(null);
  const docInputRef = useRef(null);
  const docFileType = [".ppt", ".pptx", ".docx", ".pdf", ".xls", ".xlsx"];
  const docPhotoType = [".jpg", ".jpeg", ".png", ".gif"];

  const [payload, setPayload] = useState(initPayload);
  const [titleHeight, setTitleHeight] = useState(0);
  const [articleHeight, setArticleHeight] = useState(0);
  const [showAttachment, setShowAttachment] = useState(false);
  const [showSubmitValidation, setShowSubmitValidation] = useState(false);
  const [showSubmitSuccess, setShowSubmitSuccess] = useState(false);
  const [showSubmitOnProcess, setShowSubmitOnProcess] = useState(true);
  const [showDrawerAttachment, setShowDrawerAttachment] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [attachmentType, setAttachmentType] = useState("");
  const [fileIcon, setFileIcon] = useState("");
  const [messageValidation, setMessageValidation] = useState("");
  const handleChangeTitle = (event) => {
    setPayload({ ...payload, title: event.target.value });
    setTitleHeight(titleRef.current.scrollHeight);
  };

  const handleChangeReport = (event) => {
    setPayload({ ...payload, description: event.target.value });
    setArticleHeight(articleRef.current.scrollHeight);
  };

  const onChooseAttachment = (type, optionFile = "") => {
    setAttachmentType(type);
    if (type === "docphoto") {
      if (optionFile === "file") {
        docInputRef.current.accept = [...docFileType];
      }
      docInputRef.current.click();
    } else {
      setShowAttachment(true);
    }
  };

  const handleDocFileSelected = (event) => {
    const fileData = event.target.files[0];
    const extension = fileData?.name
      .toLowerCase()
      .slice(fileData?.name.lastIndexOf("."));

    if (docPhotoType.includes(extension)) {
      if (!payload.img) {
        setPayload({ ...payload, img: fileData });
      } else {
        if (!payload.img2) {
          setPayload({ ...payload, img2: fileData });
        } else {
          setPayload({ ...payload, img3: fileData });
        }
      }
    } else {
      switch (extension) {
        case ".docx":
          setFileIcon(Assets.iconCreatePostFileDoc);
          break;
        case ".pdf":
          setFileIcon(Assets.iconCreatePostFilePdf);
          break;
        case "pptx":
          setFileIcon(Assets.iconCreatePostFilePpt);
          break;
        case ".ppt":
          setFileIcon(Assets.iconCreatePostFilePpt);
          break;
        case ".xls":
          setFileIcon(Assets.iconCreatePostFileXls);
          break;
        case ".xlsx":
          setFileIcon(Assets.iconCreatePostFileXls);
          break;
        default:
          break;
      }
      setPayload({ ...payload, file: fileData });
    }
  };
  const handleConfirmSubmitCreateReport = async () => {
    setOpenConfirmDialog(false);
    setShowSubmitOnProcess(false);
    payload.anonym = params.anonym;
    await submitCreateReport(payload).then((result) => {
      if (result.status === 200) {
        setShowSubmitSuccess(true);
      } else {
        setMessageValidation(
          JSON.stringify(result?.message.documents[0]["file[0]"])
        );
        setShowSubmitOnProcess(true);
        setShowSubmitValidation(true);
      }
    });
  };
  const handleSubmitCreateReport = async () => {
    let messageError = "";

    if (attachmentType) {
      if (!payload.title) {
        messageError = "Add Subject before submitting.";
      }

      if (!payload.description) {
        messageError = "Add Description before submitting.";
      }

      switch (attachmentType) {
        case "photo":
          if (!payload.img) {
            messageError = "Add photo before submitting.";
          }
          break;
        case "video":
          if (!payload.video) {
            messageError = "Add Video before submitting.";
          }
          break;
        case "docphoto":
          if (!payload.file) {
            messageError = "Add file before submitting.";
          }
          break;
        default:
          break;
      }

      if (messageError) {
        setMessageValidation(messageError);
      } else {
        setOpenConfirmDialog(true);
      }
    } else {
      setMessageValidation("Choose Attachment before submitting.");
      setShowSubmitOnProcess(true);
      setShowSubmitValidation(true);
    }
  };

  useEffect(() => {
    switch (attachmentType) {
      case "photo":
        if (payload.img == "" && payload.img2) {
          setPayload({ ...payload, img: payload.img2, img2: "" });
        }

        if (payload.img2 == "" && payload.img3) {
          setPayload({ ...payload, img2: payload.img3, img3: "" });
        }

        if (payload.img == "" && payload.img2 == "" && payload.img2 == "") {
          setAttachmentType("");
        }
        break;
      case "docphoto":
        if (
          payload.img == "" &&
          payload.img2 == "" &&
          payload.img2 == "" &&
          payload.file == "" &&
          payload.video == ""
        ) {
          setAttachmentType("");
        }
        break;
      default:
        break;
    }
  }, [payload]);

  useEffect(() => {
    if (messageValidation) {
      setShowSubmitValidation(true);
    }
  }, [messageValidation]);

  return (
    <div className="create-post-page">
      <div className="create-post-header">
        <TopNavigation
          titlePage={"Submit Report"}
          toPath={-1}
          setBorder={true}
          showRightIcon={showSubmitOnProcess}
          iconLeft={Assets.iconBack}
          iconRight={Assets.iconSubmit}
          onRightNavClicked={handleSubmitCreateReport}
        />
      </div>

      <div className="create-post-content">
        <div className="content-detail">
          <Container>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label className="create-post-label">
                  Report Subject
                </Form.Label>
                <Form.Control
                  as="textarea"
                  maxLength={250}
                  ref={titleRef}
                  className="create-post-input-title"
                  onChange={handleChangeTitle}
                  placeholder="Write subject here..."
                  style={{ height: titleHeight }}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label className="create-post-label">
                  Description
                </Form.Label>
                <Form.Control
                  ref={articleRef}
                  as="textarea"
                  maxLength={160}
                  className="create-post-input-article"
                  onChange={handleChangeReport}
                  placeholder="Write description here..."
                  style={{ height: articleHeight }}
                />
              </Form.Group>
            </Form>
          </Container>
        </div>

        {attachmentType === "photo" ? (
          <Container>
            <Row className="content-attachment-image">
              {payload.img && (
                <Col className="list-content-image">
                  <img
                    className="list-image"
                    src={URL.createObjectURL(payload.img)}
                    alt="list-image"
                  />
                  <span className="remove-preview-image">
                    <img
                      src={Assets.iconCreatePostCloseImage}
                      alt="delete-icon"
                      onClick={() => setPayload({ ...payload, img: "" })}
                    />
                  </span>
                </Col>
              )}
              {payload.img2 && (
                <Col className="list-content-image">
                  <img
                    className="list-image"
                    src={URL.createObjectURL(payload.img2)}
                    alt="list-image"
                  />
                  <span className="remove-preview-image">
                    <img
                      src={Assets.iconCreatePostCloseImage}
                      alt="delete-icon"
                      onClick={() => setPayload({ ...payload, img2: "" })}
                    />
                  </span>
                </Col>
              )}
              {payload.img3 && (
                <Col className="list-content-image">
                  <img
                    className="list-image"
                    src={URL.createObjectURL(payload.img3)}
                    alt="list-image"
                  />
                  <span className="remove-preview-image">
                    <img
                      src={Assets.iconCreatePostCloseImage}
                      alt="delete-icon"
                      onClick={() => setPayload({ ...payload, img3: "" })}
                    />
                  </span>
                </Col>
              )}
              {(!payload.img || !payload.img2 || !payload.img3) && (
                <Col className="list-content-image">
                  <img
                    className="list-image"
                    src={Assets.iconCreatePostDefaultImage}
                    alt="list-image"
                    onClick={() => setShowAttachment(true)}
                  />
                </Col>
              )}
            </Row>
          </Container>
        ) : (
          <Container>
            <Row className="content-attachment-video">
              {payload.video && (
                <Col className="list-content-video">
                  <video className="list-video">
                    <source
                      src={URL.createObjectURL(payload.video)}
                      type="video/mp4"
                    />
                    Your browser does not support the video tag.
                  </video>
                  <span className="remove-preview-video">
                    <img
                      src={Assets.iconCreatePostCloseImage}
                      alt="delete-icon"
                      onClick={() => {
                        setPayload({ ...payload, video: "" });
                        setAttachmentType("");
                      }}
                    />
                  </span>
                </Col>
              )}
            </Row>
          </Container>
        )}

        {!attachmentType && (
          <div className="content-attachment">
            <Container>
              <Form.Label className="create-post-label">
                Choose Attachment Type
              </Form.Label>
            </Container>
            <ListGroup>
              <ListGroupItem className="create-post-list-attachment">
                <Row onClick={() => onChooseAttachment("photo")}>
                  <Col xs={2} sm={2} md={2}>
                    <div className="icon-wrapper">
                      <i>
                        <img
                          src={Assets.iconCreatePostPhoto}
                          width="24px"
                          alt="Icon Create Post"
                        />
                      </i>
                    </div>
                  </Col>
                  <Col className="create-post-title-label">Photos</Col>
                </Row>
              </ListGroupItem>
              <ListGroupItem className="create-post-list-attachment">
                <Row onClick={() => onChooseAttachment("video")}>
                  <Col xs={2} sm={2} md={2}>
                    <div className="icon-wrapper">
                      <i>
                        <img
                          src={Assets.iconCreatePostVideo}
                          width="24px"
                          alt="Icon Create Post"
                        />
                      </i>
                    </div>
                  </Col>
                  <Col className="create-post-title-label">Videos</Col>
                </Row>
              </ListGroupItem>
              <ListGroupItem className="create-post-list-attachment">
                <Row onClick={() => onChooseAttachment("docphoto")}>
                  <Col xs={2} sm={2} md={2}>
                    <div className="icon-wrapper">
                      <i>
                        <img
                          src={Assets.iconCreatePostFile}
                          width="24px"
                          alt="Icon Create Post"
                        />
                      </i>
                    </div>
                  </Col>
                  <Col className="create-post-title-label">Document</Col>
                </Row>
              </ListGroupItem>
            </ListGroup>
          </div>
        )}

        {attachmentType === "docphoto" && (
          <div className="content-attachment-preview">
            <Container>
              <Form.Label className="attachment-preview-label">
                Attachment Document
              </Form.Label>
            </Container>
            <ListGroup>
              {payload.file ? (
                <ListGroupItem className="attachment-preview-list">
                  <Row>
                    <Col xs={2} sm={2} md={2}>
                      <div className="attachment-preview-icon">
                        <i>
                          <img
                            src={fileIcon}
                            width="24px"
                            alt="Icon Attachment"
                          />
                        </i>
                      </div>
                    </Col>
                    <Col
                      xs={8}
                      sm={8}
                      md={8}
                      className="attachment-preview-file-name"
                    >
                      {payload?.file?.name}
                    </Col>
                    <Col
                      xs={2}
                      sm={2}
                      md={2}
                      className="attachment-preview-remove-file"
                    >
                      <img
                        className="delete-icon"
                        src={Assets.iconCreatePostCloseImage}
                        alt="delete-icon"
                        onClick={() => setPayload({ ...payload, file: "" })}
                      />
                    </Col>
                  </Row>
                </ListGroupItem>
              ) : (
                <ListGroupItem className="attachment-preview-list-add-file">
                  <Row onClick={() => onChooseAttachment("docphoto", "file")}>
                    <Col xs={2} sm={2} md={2}>
                      <div className="attachment-preview-add-file">
                        <i>
                          <img
                            src={Assets.iconCreatePostAddFile}
                            alt="Icon Add Attachment"
                          />
                        </i>
                      </div>
                    </Col>
                  </Row>
                </ListGroupItem>
              )}
            </ListGroup>
          </div>
        )}
      </div>

      <input
        type="file"
        ref={docInputRef}
        style={{ display: "none" }}
        accept={[...docPhotoType, ...docFileType]}
        onClick={(event) => (event.target.value = null)}
        onChange={handleDocFileSelected}
      />

      <AttachmentDialog
        show={showAttachment}
        onClose={() => setShowAttachment(false)}
        attachmentType={attachmentType}
        showAttachmentCamera={() => setShowDrawerAttachment(true)}
        setAttachmentType={setAttachmentType}
        payload={payload}
        setPayload={setPayload}
      />

      <SubmitCreateReportDialogSuccess
        show={showSubmitSuccess}
        onClose={() => {
          setShowSubmitSuccess(false);
          setPayload(initPayload);
          setAttachmentType("");
          setTitleHeight(0);
          setArticleHeight(0);
          navigate(-1);
        }}
      />
      <ConfirmationDialog
        title="Confirmation"
        confirmLabel="Submit"
        cancelLabel="Back"
        message="Do you want to submit your reports? You cannot edit once you submited.?"
        show={openConfirmDialog}
        onCancel={() => {
          setOpenConfirmDialog(false);
        }}
        onConfrim={() => handleConfirmSubmitCreateReport()}
      />
      <SubmitCreateReportDialogValidation
        show={showSubmitValidation}
        onClose={() => {
          setShowSubmitValidation(false);
          setMessageValidation("");
          setShowSubmitOnProcess(true);
        }}
        messageValidation={messageValidation}
      />

      <Drawer
        open={showDrawerAttachment}
        onClose={() => setShowDrawerAttachment(false)}
        size={"100%"}
        direction="bottom"
        overlayColor={"#080707"}
        overlayOpacity={0.5}
        style={{
          padding: "20px",
          textAlign: "center",
        }}
      >
        <Container>
          <CameraRecorder
            payload={payload}
            setPayload={setPayload}
            attachmentType={attachmentType}
            onClose={() => setShowDrawerAttachment(false)}
          />
        </Container>
      </Drawer>
    </div>
  );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  submitCreateReport: dispatch.ReportSM.submitCreateReport,
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateReportPage);
